<template>
  <div class="block dhyc" id="dhyc">
    <div class="itemTitBox wow animated bounceInRight">
      <p class="big">大会议程</p>
      <p class="small">AGENDA</p>
    </div>
    <div class="meetingList">
      <img class="line wow animated bounceInLeft" src="../assets/images/line.png" alt="">
      <div class="meetingItem" v-for="(item, index) in dataJson.conference_agenda" :key="index">
        <div class="date wow animated bounceInLeft">{{item.time}}</div>
        <div class="ball wow animated bounceInLeft"></div>
        <div class="tagBg wow animated bounceInUp"><span>{{item.content}}</span></div>
      </div>
    </div>
    <div class="childrenList">
      <div class="children">
        <img class="titleImg wow animated bounceInLeft" src="../assets/images/tit07.png" alt="">
        <div class="luntanBox">
          <div class="luntanList">
            <div class="luntanItem wow animated bounceInUp" v-for="(item, index) in dataJson.conference_agenda1" :key="index">
              <img class="icon" src="../assets/images/triangle_icon.png" alt="">
              <div class="content">
                <p>{{item.time}}</p>
                <p>{{item.content}}</p>
                <p>{{item.people}}</p>
                <p>{{item.company}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="children">
        <img class="titleImg wow animated bounceInLeft" src="../assets/images/tit08.png" alt="">
        <div class="luntanBox">
          <div class="luntanList">
            <div class="luntanItem wow animated bounceInUp" v-for="(item, index) in dataJson.conference_agenda2" :key="index">
              <img class="icon" src="../assets/images/triangle_icon.png" alt="">
              <div class="content">
                <p>{{item.time}}</p>
                <p>{{item.content}}</p>
                <p>{{item.people}}</p>
                <p>{{item.company}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="children">
        <img class="titleImg wow animated bounceInLeft" src="../assets/images/tit09.png" alt="">
        <div class="luntanBox">
          <div class="luntanList">
            <div class="luntanItem wow animated bounceInUp" v-for="(item, index) in dataJson.conference_agenda3" :key="index">
              <img class="icon" src="../assets/images/triangle_icon.png" alt="">
              <div class="content">
                <p>{{item.time}}</p>
                <p>{{item.content}}</p>
                <p>{{item.people}}</p>
                <p>{{item.company}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dataJson from "../assets/index.json";
export default {
  data() {
    return {
      dataJson
    };
  },
};
</script>
<style lang="less" scoped>
@import url('../views/index.less');
.meetingList {
  width: 779px;
  margin: 0 auto;
  position: relative;
  .line {
    width: 2px;
    height: 100%;
    position: absolute;
    left: 170px;
  }
  .meetingItem {
    width: 100%;
    display: flex;
    margin-top: 14px;
    align-items: center;
    .date {
      width: 150px;
      text-align: right;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .ball {
      margin-left: 15px;
      margin-right: 17px;
      width: 11px;
      height: 11px;
      background: linear-gradient(-34deg, #0040C3 0%, #690087 100%);
      border-radius: 50%;
    }
    .tagBg {
      width: 495px;
      box-sizing: border-box;
      padding: 12px 36px;
      background: url('../assets/images/tagBg.png') no-repeat;
      background-size: 100% 100%;
      >span {
        font-size: 18px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 1.2;
      }
    }
  }
}
.childrenList {
  width: 100%;
  .children {
    margin-top: 78px;
    .titleImg {
      margin: 0 auto;
      display: block;
      width: 270px;
      height: 28px;
      margin-bottom: 20px;
    }
    .luntanBox {
      margin: 0 auto;
      width: 783px;
      background: url('../assets/images/ltrcBg.png') no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 58px 30px;
      .luntanList {
        width: 100%;
        .luntanItem {
          margin-bottom: 10px;
          width: 100%;
          display: flex;
          align-items: center;
          .icon {
            width: 11px;
            height: 16px;
            display: block;
            margin-right: 17px;
          }
          .content {
            width: calc(100% - 28px);
            // height: 36px;
            background: #000051;
            line-height: 1.5;
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 12px 0;
            transition: all 0.6s;
            >p {
              text-align: center;
              width: 33%;
              font-size: 15px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
              color: #FFFFFF;
            }
            &:hover{
              transform: scale(1.05);
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dhyc.vue